import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "./images/main_logo_bg_remove.png";

const Nave = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav
      className="flex items-center justify-between px-6 bg-white shadow-md fixed top-0 w-full z-50"
      style={{ height: "64px" }}
    >
      <div className="flex items-center h-full">
        <Link to="/" className="flex items-center h-full">
          <img src={logo} alt="India's Home Tuition" className="mt-7 h-44 w-auto object-contain" />
        </Link>
      </div>

      {/* Hamburger Menu */}
      <div
        className="md:hidden flex flex-col space-y-1 cursor-pointer"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span
          className={`block h-0.5 w-6 bg-black transform transition duration-300 ease-in-out ${
            menuOpen ? "rotate-45 translate-y-1.5" : ""
          }`}
        ></span>
        <span
          className={`block h-0.5 w-6 bg-black transition duration-300 ease-in-out ${
            menuOpen ? "opacity-0" : "opacity-100"
          }`}
        ></span>
        <span
          className={`block h-0.5 w-6 bg-black transform transition duration-300 ease-in-out ${
            menuOpen ? "-rotate-45 -translate-y-1.5" : ""
          }`}
        ></span>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:flex space-x-6 text-lg font-medium items-center">
        <Link to="/" className="hover:text-blue-600 transition">Home</Link>
        <Link to="/About2" className="hover:text-blue-600 transition">About</Link>
        <Link to="/Services" className="hover:text-blue-600 transition">Services</Link>
        <Link to="/Programs" className="hover:text-blue-600 transition">Programs</Link>

        <div className="relative group">
          <button className="hover:text-blue-600 transition flex items-center">
            Pages
            <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div className="absolute hidden group-hover:block bg-white shadow-lg mt-2 rounded-md py-2 w-40">
            <Link to="/blog" className="block px-4 py-2 hover:bg-blue-100 transition">Our Blog</Link>
            <Link to="/team" className="block px-4 py-2 hover:bg-blue-100 transition">Our Team</Link>
            <Link to="/testimonial" className="block px-4 py-2 hover:bg-blue-100 transition">Testimonial</Link>
            <Link to="/404" className="block px-4 py-2 hover:bg-blue-100 transition">404 Page</Link>
          </div>
        </div>

        <Link to="/Contact" className="hover:text-blue-600 transition">Contact</Link>

        {/* New: Login & Signup */}
        <Link to="/login" className="text-orange-600 hover:text-orange-800 font-semibold transition">Login</Link>
        <Link to="/signup" className="bg-blue-600 text-white px-4 py-1 rounded-md hover:bg-blue-700 transition">Signup</Link>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`fixed top-16 right-0 w-64 bg-white shadow-lg h-screen p-6 space-y-6 transform transition-transform duration-300 ease-in-out md:hidden ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {[
          { to: "/", label: "Home" },
          { to: "/About2", label: "About" },
          { to: "/Services", label: "Services" },
          { to: "/Programs", label: "Programs" },
          { to: "/blog", label: "Our Blog" },
          { to: "/team", label: "Our Team" },
          { to: "/testimonial", label: "Testimonial" },
          { to: "/404", label: "404 Page" },
          { to: "/Contact", label: "Contact" },
          { to: "/login", label: "Login", extra: "text-orange-600 font-semibold" },
          { to: "/signup", label: "Signup", extra: "bg-blue-600 text-white text-center rounded-md py-2" },
        ].map(({ to, label, extra }) => (
          <Link
            key={to}
            to={to}
            className={`block text-lg font-medium hover:text-blue-600 transition ${extra || ""}`}
            onClick={() => setMenuOpen(false)}
          >
            {label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Nave;
